import { type StudentDashboardConfig } from 'AdmissionsGuidance';
import { memo } from 'react';
import { WelcomeMessage } from './WelcomeMessage';
import { AcceptedMessage } from './AcceptedMessage';
import { GraduatedMessage } from './GraduatedMessage';

function TopMessageComponent({ studentDashboardConfig }: { studentDashboardConfig: StudentDashboardConfig | null }) {
    if (studentDashboardConfig?.showAcceptedTopMessage) {
        return <AcceptedMessage />;
    }

    if (studentDashboardConfig?.showGraduatedTopMessage) {
        return <GraduatedMessage />;
    }

    return <WelcomeMessage />;
}

export const TopMessage = memo(TopMessageComponent) as typeof TopMessageComponent;
